<template>
  <section :class="['row', {'row--slidup': isInView}]">
    <header class="row__header">
      <h2 class="row__title row__title--small">
        Co <span class="row__highlight">zyskujesz?</span>
      </h2>
    </header>
    <ul class="benefits">
      <li class="benefits__benefit">
        <img class="benefits__icon" :src="require('@/assets/img/icon-people.svg')">
        <p class="benefits__text">
          Twój biznes odpowiada potrzebom współczesnego stylu życia.
        </p>
      </li>
      <li class="benefits__benefit">
        <img class="benefits__icon" :src="require('@/assets/img/icon-tools.svg')">
        <p class="benefits__text">
          Procesy serwisowe ulegają digitalizacji oraz automatyzacji.
        </p>
      </li>
      <li class="benefits__benefit">
        <img class="benefits__icon" :src="require('@/assets/img/icon-hand.svg')">
        <p class="benefits__text">
          Jesteś mniej uzależniony od dostępności Klienta.
        </p>
      </li>
      <li class="benefits__benefit">
        <img class="benefits__icon" :src="require('@/assets/img/icon-clock.svg')">
        <p class="benefits__text">
          Zyskujesz czas na dodatkowe zadania.
        </p>
      </li>
      <li class="benefits__benefit">
        <img class="benefits__icon" :src="require('@/assets/img/icon-boxes.svg')">
        <p class="benefits__text">
          Cross-selling oraz upselling usług.
        </p>
      </li>
      <li class="benefits__benefit">
        <img class="benefits__icon" :src="require('@/assets/img/icon-star.svg')">
        <p class="benefits__text">
          Zwiększony komfort dla Twojego klienta.
        </p>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'benefits',
};
</script>

<style lang="scss" scoped>
.row {
  padding-bottom: 30px;
}

.benefits {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  justify-content: center;
  margin: 80px auto 0;
  max-width: 1120px;
  padding: 0;
  width: 100%;
}

.benefits__benefit {
  margin-bottom: 80px;
  min-width: 300px;
  padding: 0 30px;
  width: calc(100% / 3);
}

.benefits__icon {
  margin-bottom: 30px;
}

.benefits__text {
  font-size: 1.125em;
  line-height: 1.333em;
  margin: 0;
}
</style>
